import { useMutation, type MutationHookOptions } from "@apollo/client"
import customerTenantRemoveMutation from "@/v2-backoffice-client/customer/tenant/remove/customer.tenant.remove.mutation.gql"
import type {
  CustomerTenantRemoveMutation,
  CustomerTenantRemoveMutationVariables,
} from "@/v2-backoffice-client/customer/tenant/remove/__types__/customer.tenant.remove.mutation"

type RemoveOptions = MutationHookOptions<
  CustomerTenantRemoveMutation,
  CustomerTenantRemoveMutationVariables
>

export function useCustomerTenantRemoveMutation(options?: RemoveOptions) {
  return useMutation<
    CustomerTenantRemoveMutation,
    CustomerTenantRemoveMutationVariables
  >(customerTenantRemoveMutation, options)
}
